var _defs, _path, _path2, _path3, _path4, _path5, _polygon, _polygon2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFdIsotipoColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 205.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00a5c8;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2{fill:#068099;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.06,185.8a93.89,93.89,0,0,1-68.77-11.41l12.87-8.73a80.75,80.75,0,0,0,57.75,5.44Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,136.54c0,66.41-79.64,90.36-118.22,47.87l-9.62,3.44,4.27-33.93,29.31,21.91-8.51,3c30.47,27.79,88.9,8.49,88.9-42.33,0-24.51-20.9-49-44.5-54.77l1-14C229.35,74,256,105,256,136.54Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.89,99.25a65.89,65.89,0,0,0,1.92,11.65,64.45,64.45,0,0,0,2.9,8.71l74-49.16V45.31Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.32,61.34l30.49,20.23,2.36-34.12-8.89,3.76C162.49,20,129.67,0,94,0A94,94,0,0,0,12.44,140.74L24,132.9A80.18,80.18,0,0,1,94,13.82c30.06,0,57.86,16.69,71.48,42.8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.75,162.62V187.5l102-69.19V93.17Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "172.15 141.18 172.15 166.31 138.93 142.31 105.7 118.31 105.7 93.17 138.93 117.18 172.15 141.18"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "206.39 117.19 206.39 141.82 138.93 94 105.7 70.45 105.7 45.31 138.93 69.03 206.39 117.19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFdIsotipoColor);
export default __webpack_public_path__ + "static/media/fd-isotipo-color.33cf07424142cd3bc1298a427fc3d401.svg";
export { ForwardRef as ReactComponent };